import type {ReactNode} from 'react'
import {cn} from '@/lib/utils'

type MutedStatBoxVariant = 'muted' | 'success' | 'danger'

interface MutedStatBoxProps {
    children: ReactNode
    variant?: MutedStatBoxVariant
    className?: string
    'data-testid'?: string
}

/* eslint-disable i18next/no-literal-string -- CSS class constants */
const variantClasses: Record<MutedStatBoxVariant, string> = {
    muted: 'bg-muted',
    success: 'bg-status-success-subtle dark:bg-status-success-subtle',
    danger: 'bg-status-danger-subtle dark:bg-status-danger-subtle',
}
/* eslint-enable i18next/no-literal-string */

export function MutedStatBox({children, variant = 'muted', className, 'data-testid': testId}: MutedStatBoxProps) {
    return (
        <div
            className={cn('rounded-lg px-4 py-2', variantClasses[variant], className)}
            data-testid={testId}
        >
            {children}
        </div>
    )
}
